import { Injectable } from '@angular/core';
import { NetworkService } from '../shared/network.service';

@Injectable({
  providedIn: 'root'
})
export class MainService {

  constructor(private _networkService: NetworkService) {}

 
  generate(body: any) {
    return this._networkService.post("api/inviteCode",body, null, "bearer");
  }
  
  deletePlaylistApi(body: any) {
    return this._networkService.delete("api/playList/"+body,null, null, "bearer");
  }
  changePassword(body: any) {
    return this._networkService.post("api/user/password/change", body, null, "bearer");
  }
  deleteAccount() {
    return this._networkService.post("api/user/delete", null, null, "bearer");
  }

}
